<template lang='pug'>
.facility-slide-out-details
	h1.title {{ facility.name }} No. {{ facility.number }}
	.info-group
		//- p(v-if='facility.locationDescription') {{ facility.locationDescription }}
		//- p.green {{ facility.status }}
		//- p {{ facility.facilitiesType.description }}

		.expand-info(@click='setExpandState')
			p Expand all Info
			.clickable-arrow(:class='expandState')

	.info
		list-layout(
			:layout='listItems'
			:parentObj='facility'
			:class='{ "slide-in" : expandState === "open" }'
		)

</template>

<script>
import ListLayout from '@/components/ListLayout';

import { objectOrNull } from '@/lib/vue-validators';
import { FormatDate } from '@/lib/utils';

export default {
	name : 'facility',

	props : {
		facility : {
			required  : true,
			validator : objectOrNull,
		}
	},

	data : () => ( {
		expandState : 'close',

		listItems : {
			items : {
				name           : 'Facility Name',
				facilitiesType : {
					items : {
						description : 'Facility Type',
					},
				},
				number              : 'Facility Number',
				status              : 'Status',
				owner               : 'Owner',
				locationDescription : 'Location Description',
				normalFlow          : 'Normal Capacity',
				maxFlow             : 'Max Capacity',
				comments            : 'Comments',
				driveLink           : 'Drive Link',
				purchasedFromFclc   : 'Purchased From FCLC?',
				deeded              : 'Deeded?',
			},
		}
	} ),

	methods : {

		setExpandState() {
			const { expandState } = this;
			this.expandState = expandState === 'open' ? 'close' : 'open';
		},

		dateFormat( date ) {
			return FormatDate( date, 'MM/DD/YYYY' );
		},

	},

	components : {
		ListLayout,
	}

};
</script>

<style lang='scss'>

.facility-slide-out-details {
	display: flex;
	flex-flow: column;
	width: 100%;
	align-items: center;
	padding: 0 30px;

	h1.title {
		width: 100%;
		text-align: center;
		color: $text-primary;
		margin: 0;
		margin-top: 15px;
	}

	.info-group {
		margin-top: 15px;

		p {
			text-align: center;

			+ p {
				margin-top: 10px;
			}

			&.green {
				color: $color-primary;
			}
		}

		.expand-info {
			position: relative;
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			margin: auto;
			width: fit-content;
			margin-top: 15px;
			cursor: pointer;

			p {
				color: $alternateGrey;
				font-weight: 300;
			}

			.clickable-arrow {
				position: relative;
				left: 10px;

				&::before, &::after {
					background: $alternateGrey;
				}
			}
		}
	}

	.info .list-layout {

		.list-item.item-name {
			flex: 0 0 66%;
		}

		.list-item {
			flex: 0 0 33%;
		}
	}
}

@media only screen and ( max-width: 640px ) {

	.facility-slide-out-details {
		align-items: flex-start;

		h1.title {
			text-align: left;
			margin-top: 0;
		}

		.info-group,
		.expand-info {
			margin-top: 0 !important;
		}

		.info .list-layout .section {

			.list-item {
				flex: 0 0 50%;

				&.item-name {
					flex: 0 0 100%;
				}

				&.item-purchasedFromFclc,
				&.item-deeded {
					display: flex;
					justify-content: space-between;
				}

				&.item-purchasedFromFclc,
				&.item-deeded {
					flex: 0 0 100%;
				}
			}
		}
	}
}
</style>
